import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var KeyboardShortcutSvg = function KeyboardShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.22 13.631H7.34v-1.373H5.22zM7.339 17.066H5.22v-1.374H7.34zM9.034 13.631h2.118v-1.373H9.035zM18.78 13.631H16.66v-1.373h2.119zM12.848 13.631h2.118v-1.373h-2.118zM18.78 17.066H16.66v-1.374h2.119zM9.034 17.066h5.932v-1.374H9.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.915 3.5v2.612l-4.237 1.717v.994H22V20.5H2V8.823h9.322V6.9l4.237-1.718V3.5zm-13.56 6.697v8.93h17.29v-8.93z",
    clipRule: "evenodd"
  }));
};
export var KeyboardShortcut = function KeyboardShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: KeyboardShortcutSvg
  }));
};